import React from "react";
import { useLocation } from "react-router";
import { Link, useSearchParams } from "react-router-dom";

interface IProps {
  link: string;
  title: string;
  onClick?: () => void;
}

const NaviLink: React.FC<IProps> = ({ link, title, onClick }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isActiveRoute = (): boolean => {
    const currentPath = location.pathname;
    const currentOfferId = searchParams.get("offerId");
    const targetUrl = new URL(link, window.location.origin);
    const targetPath = targetUrl.pathname;
    const targetOfferId = targetUrl.searchParams.get("offerId");

    if (currentPath === targetPath) {
      if (targetOfferId) {
        return currentOfferId === targetOfferId;
      }
      return true;
    }
    return false;
  };

  return (
    <Link title={title} onClick={onClick} className={isActiveRoute() ? "navi-link active" : "navi-link"} to={link}>
      {title}
    </Link>
  );
};

export default NaviLink;
